import React, { useRef, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import css from './progress-bar.scss';

import { Progress } from './progress-bar-helpers';

const ProgressBar = ({
    accuracyBadRangeCount,
    accuracyBestRangeCount,
    accuracyGoodRangeCount,
    accuracyMiddleRangeCount,
    accuracyWorstRangeCount,
    accuracyTotalAvailableRangeCount,
    progressBarWidth = 300
}) => {
    const [chartData, setChartData] = useState([]);

    const ref = useRef();

    const isAllAssigned =
        accuracyTotalAvailableRangeCount ===
        accuracyBestRangeCount +
            accuracyGoodRangeCount +
            accuracyMiddleRangeCount +
            accuracyBadRangeCount +
            accuracyWorstRangeCount;

    useEffect(() => {
        const barWidth = ref.current.offsetWidth || progressBarWidth;
        const unitLength =
            accuracyTotalAvailableRangeCount === 0
                ? 0
                : barWidth / accuracyTotalAvailableRangeCount;

        const data = [
            {
                style: 'green',
                width: accuracyBestRangeCount * unitLength
            },
            {
                style: 'light-green',
                width: accuracyGoodRangeCount * unitLength
            },
            {
                style: 'light-orange',
                width: accuracyMiddleRangeCount * unitLength
            },
            {
                style: 'orange',
                width: accuracyBadRangeCount * unitLength
            },
            {
                style: 'red',
                width: accuracyWorstRangeCount * unitLength
            },
            {
                style: isAllAssigned ? 'hidden' : 'white',
                width: 0
            }
        ];
        setChartData(data);
    }, [ref.current]);
    return (
        <div ref={ref} id="progress-bar" className={css['progress-wrapper']}>
            {chartData.map(({ style, width }) => (
                <Progress style={style} width={width} key={style} />
            ))}
        </div>
    );
};

ProgressBar.propTypes = {
    accuracyBadRangeCount: PropTypes.number.isRequired,
    accuracyBestRangeCount: PropTypes.number.isRequired,
    accuracyGoodRangeCount: PropTypes.number.isRequired,
    accuracyMiddleRangeCount: PropTypes.number.isRequired,
    accuracyWorstRangeCount: PropTypes.number.isRequired,
    accuracyTotalAvailableRangeCount: PropTypes.number.isRequired,
    progressBarWidth: PropTypes.number
};

export default ProgressBar;



// WEBPACK FOOTER //
// ./components/progress-bar/progress-bar.js